import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const CustomSnackbar = ({
  message,
  action,
  ButtonProps,
  SnackbarProps,
  customParameters,
}) => (
  <Snackbar autoHideDuration={6000} {...SnackbarProps}>
    <Alert
      variant="filled"
      severity={customParameters?.type}
      action={
          action != null && (
            <Button color="inherit" size="small" {...ButtonProps}>
              {action}
            </Button>
          )
        }
    >
      {message}
    </Alert>
  </Snackbar>
);

CustomSnackbar.defaultProps = {
  message: '',
  action: '',
  ButtonProps: {},
  SnackbarProps: {},
  customParameters: {
    type: 'info',
  },
};
CustomSnackbar.propTypes = {
  message: PropTypes.string,
  action: PropTypes.string,
  ButtonProps: PropTypes.object,
  SnackbarProps: PropTypes.object,
  customParameters: PropTypes.shape({
    type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  }),
};

export default CustomSnackbar;
